export default __webpack_public_path__ + "static/media/Flag_of_Germany.1708c5f7.svg";